import * as React from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Zoom from '@mui/material/Zoom';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import { motion, useScroll, useSpring } from 'framer-motion';

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, restDelta: 0.001 });
  const [showTop, setShowTop] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <motion.div
        style={{
          scaleX,
          transformOrigin: '0%',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          zIndex: 2000,
          background: 'linear-gradient(90deg, hsl(210,98%,55%), hsl(265,90%,62%), hsl(190,95%,55%))',
        }}
      />
      <Zoom in={showTop}>
        <Box
          sx={{ position: 'fixed', bottom: 28, right: 28, zIndex: 1500 }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <Fab
            size="medium"
            aria-label="Back to top"
            sx={{
              background: 'linear-gradient(135deg, hsl(210,98%,52%), hsl(265,90%,60%))',
              color: '#fff',
              boxShadow: '0 8px 24px hsla(220,90%,50%,0.45)',
              '&:hover': {
                background: 'linear-gradient(135deg, hsl(210,98%,58%), hsl(265,90%,66%))',
              },
            }}
          >
            <KeyboardArrowUpRoundedIcon />
          </Fab>
        </Box>
      </Zoom>
    </>
  );
}
